import _Vue from "vue";
// import vue from "vue";
import Http from "@/api/http/fetch";
declare module "vue/types/vue" {
  export interface Vue {
    $native: any;
    $Toast: any;
    $Dialog: any;
  }
}
export function InstanceMethods(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$native = Http;
}
